import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

import './styles.css';
import DataTable from '../../../DataTable';
import { sortObjectByKey } from '../../../../utilities/helpers';
import {
  JOB_STATUS_CODES,
  SORT_DIRECTIONS,
  COLORS,
} from '../../../../constants';

const propTypes = {
  classes: PropTypes.shape({
    tableWrapper: PropTypes.string,
  }).isRequired,
  jobs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      dateCreated: PropTypes.string.isRequired,
      customerDetail: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        phoneNumber: PropTypes.string,
      }),
      status: PropTypes.string.isRequired,
      notes: PropTypes.string,
    }),
  ),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      title: PropTypes.string,
      sort: PropTypes.shape({
        enabled: PropTypes.bool,
        customSort: PropTypes.func,
      }).isRequired,
      name: PropTypes.string,
      cell: PropTypes.func,
    }),
  ).isRequired,
  sort: PropTypes.shape({
    column: PropTypes.string,
    direction: PropTypes.oneOf([SORT_DIRECTIONS.DESC, SORT_DIRECTIONS.ASC]),
  }).isRequired,
  onSort: PropTypes.func.isRequired,
};

const defaultProps = {
  jobs: [],
};

export const JobsContainer = props => {
  const { classes, jobs, sort, columns } = props;

  const getSortedRows = () => {
    const column = columns.find(col => col.name === sort.column);
    // this column does exist
    if (column !== undefined) {
      const rows = jobs.map(job => {
        switch (job.statusCode) {
          case JOB_STATUS_CODES.STATUS_01:
            return {
              ...job,
              rowLeftBarColor: COLORS.BLUE_LIGHT,
            };
          case JOB_STATUS_CODES.STATUS_02:
            return {
              ...job,
              rowLeftBarColor: COLORS.YELLOW_DARK,
            };
          case JOB_STATUS_CODES.STATUS_03:
            return {
              ...job,
              rowLeftBarColor: COLORS.GREEN,
            };
          default:
            return {
              ...job,
              rowLeftBarColor: COLORS.GREY_DARK,
            };
        }
      });

      // this column has a custom sort function
      if (column.customSort) {
        return rows.sort(column.customSort(sort.column, sort.direction));
      }

      return rows.sort(sortObjectByKey(sort.column, sort.direction));
    }

    // the column does not exist, so there must be something wrong with the data
    // then we return an empty array
    return [];
  };

  const handleSort = (column, direction) => {
    const { onSort } = props;

    onSort(column, direction);
  };

  return (
    <div id="jobs-table" className={classes.tableWrapper}>
      <DataTable
        columns={columns}
        data={getSortedRows(jobs, sort)}
        sort={sort}
        onSort={handleSort}
      />
    </div>
  );
};

JobsContainer.propTypes = propTypes;
JobsContainer.defaultProps = defaultProps;

export default withStyles(styles)(JobsContainer);
